// Generated by `yarn tokens:import --aos-ds` from the Figma component set "TimeStamp" (16650:57747). Do not edit.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const timestampContract = {
    component: 'TimeStamp',
    nodeId: '16650:57747',
    section: '[Web] Dashboard',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [
        { component: 'Timestamp', variants: [] },
        { component: 'TimestampOutdated', variants: [] },
    ],
    stateAxis: null,
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [] as readonly ContractDisagreement[],
    textStyleIds: [],
    props: {
        showTooltip: { kind: 'boolean' },
        variant: { kind: 'enum', values: ['default', 'outdated'] },
    },
    variants: {
        'variant=default': {
            container: 'gap-xs items-center',
            label: '',
            icon: 'text-content-muted',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                Vector: 'w-[1.25rem] h-[1.25rem]',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I16650:57757;16650:49838',
                    width: 20,
                    height: 20,
                    paths: [
                        {
                            d: 'M10 20C7.44444 20 5.21759 19.1528 3.31944 17.4583C1.4213 15.7639 0.333333 13.6481 0.0555556 11.1111H2.33333C2.59259 13.037 3.44907 14.6296 4.90278 15.8889C6.35648 17.1481 8.05556 17.7778 10 17.7778C12.1667 17.7778 14.0046 17.0231 15.5139 15.5139C17.0231 14.0046 17.7778 12.1667 17.7778 10C17.7778 7.83333 17.0231 5.99537 15.5139 4.48611C14.0046 2.97685 12.1667 2.22222 10 2.22222C8.72222 2.22222 7.52778 2.51852 6.41667 3.11111C5.30556 3.7037 4.37037 4.51852 3.61111 5.55556H6.66667V7.77778H0V1.11111H2.22222V3.72222C3.16667 2.53704 4.31944 1.62037 5.68056 0.972222C7.04167 0.324074 8.48148 0 10 0C11.3889 0 12.6898 0.263889 13.9028 0.791667C15.1157 1.31944 16.1713 2.03241 17.0694 2.93056C17.9676 3.8287 18.6806 4.88426 19.2083 6.09722C19.7361 7.31019 20 8.61111 20 10C20 11.3889 19.7361 12.6898 19.2083 13.9028C18.6806 15.1157 17.9676 16.1713 17.0694 17.0694C16.1713 17.9676 15.1157 18.6806 13.9028 19.2083C12.6898 19.7361 11.3889 20 10 20ZM13.1111 14.6667L8.88889 10.4444V4.44444H11.1111V9.55556L14.6667 13.1111L13.1111 14.6667Z',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [{ component: 'Timestamp', variants: [] }],
        },
        'variant=outdated': {
            container: 'w-[1.5rem] h-[1.5rem]',
            label: '',
            icon: 'text-status-caution',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                Vector: 'w-[1.25rem] h-[1.25rem]',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I16650:57768;16650:49840',
                    width: 20,
                    height: 20,
                    paths: [
                        {
                            d: 'M18.4091 14.1162L16.9444 12.6515C17.2138 12.1633 17.42 11.633 17.5631 11.0606C17.7062 10.4882 17.7778 9.89899 17.7778 9.29293C17.7778 7.32323 17.0918 5.65236 15.7197 4.2803C14.3476 2.90825 12.6768 2.22222 10.7071 2.22222C10.1178 2.22222 9.54125 2.29377 8.97727 2.43687C8.4133 2.57997 7.87879 2.79461 7.37374 3.08081L5.88384 1.59091C6.60774 1.1532 7.37795 0.81229 8.19444 0.568182C9.01094 0.324074 9.84848 0.20202 10.7071 0.20202C11.9697 0.20202 13.1524 0.441919 14.2551 0.921717C15.3577 1.40152 16.3173 2.04966 17.1338 2.86616C17.9503 3.68266 18.5985 4.64226 19.0783 5.74495C19.5581 6.84764 19.798 8.0303 19.798 9.29293C19.798 10.1852 19.6759 11.0354 19.4318 11.8434C19.1877 12.6515 18.8468 13.4091 18.4091 14.1162ZM11.7172 7.42424L9.69697 5.40404V4.24242H11.7172V7.42424ZM18.5859 20L15.5556 16.9697C14.8485 17.4074 14.0909 17.7525 13.2828 18.0051C12.4747 18.2576 11.6162 18.3838 10.7071 18.3838C8.38384 18.3838 6.35943 17.6136 4.63384 16.0732C2.90825 14.5328 1.91919 12.6094 1.66667 10.303H3.73737C3.97306 12.0539 4.75168 13.5017 6.07323 14.6465C7.39478 15.7912 8.93939 16.3636 10.7071 16.3636C11.33 16.3636 11.9234 16.2921 12.4874 16.149C13.0513 16.0059 13.5859 15.7912 14.0909 15.5051L5.85859 7.27273H1.61616V3.0303L0 1.41414L1.41414 0L20 18.5859L18.5859 20Z',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [{ component: 'TimestampOutdated', variants: [] }],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
